import CONFIG from '../../config';

export const buildSearchPaginationUrls = ({
  asPath,
  afterCursor,
  prevCursor,
  pageInfo,
  hostSum
}) => {
  const basePath = asPath.split('?')[0];
  const currentParams = new URLSearchParams(
    asPath.includes('?') ? asPath.split('?')[1] : ''
  );
  currentParams.delete('after');
  currentParams.delete('prev');
  const baseQuery = currentParams.toString();

  const protocol =
    hostSum?.protocol ||
    (typeof window !== 'undefined'
      ? window.location.protocol.replace(':', '')
      : CONFIG.protocol);
  const host =
    hostSum?.host ||
    (typeof window !== 'undefined' ? window.location.host : CONFIG.host);

  const base = `${protocol}://${host}${basePath}`;
  const baseQueryPrefix = baseQuery ? `?${baseQuery}&` : '?';

  const nextPageUrl = pageInfo?.hasNextPage
    ? `${base}${baseQueryPrefix}after=${encodeURIComponent(pageInfo.endCursor)}${afterCursor ? `&prev=${encodeURIComponent(afterCursor)}` : ''}`
    : null;

  let prevPageUrl = null;
  if (afterCursor && prevCursor) {
    prevPageUrl = `${base}${baseQueryPrefix}after=${encodeURIComponent(prevCursor)}`;
  } else if (afterCursor) {
    prevPageUrl = baseQuery ? `${base}?${baseQuery}` : base;
  }

  let canonicalUrl = null;
  if (afterCursor) {
    const canonicalParams = new URLSearchParams(baseQuery);
    canonicalParams.set('after', afterCursor);
    canonicalUrl = `${base}?${canonicalParams.toString()}`;
  }

  return { nextPageUrl, prevPageUrl, canonicalUrl };
};
